export const copyToClipboard = async (url, setState) => {
  setState(false);
  try {
    await navigator.clipboard.writeText(`${url}`);
    alert(`Link copied to clipboard`);
  } catch (err) {
    console.error("Failed to copy text: ", err);
  } finally {
    setState(true);
  }
};
